"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var amplitude = _interopRequireWildcard(require("@amplitude/marketing-analytics-browser"));
var _OneTrust = _interopRequireDefault(require("./OneTrust"));
var _anonymous = _interopRequireDefault(require("./anonymous"));
var _common = require("./common");
var _utils = _interopRequireDefault(require("../../utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// the amount of time to wait before rechecking if we can initialize
var INITIALIZE_RECHECK_DELAY = 100;
// the amount of times to attempt re-initialization before falling back
// to sending events anonymously
var INITIALIZE_RECHECK_MAX = 20;
var DEFAULT_AMPLITUDE_CONFIG = {
  trackingOptions: {
    ip_address: false
  },
  transport: amplitude.Types.TransportType.SendBeacon,
  minIdLength: 1
};
var conditionallyAddKey = function conditionallyAddKey(keyName, value, out) {
  if (value) {
    // the whole point of this method is to populate a single object with props,
    // so passing that object around by reference is the most performant
    // eslint-disable-next-line no-param-reassign
    out[keyName] = value;
  }
};

/**
 * Attempts to read the Amplitude device ID from cookie
 *
 * @param apiToken The Amplitude API token
 * @returns The cookie device ID or undefined if it can't be found
 */
var getDeviceIdFromCookie = function getDeviceIdFromCookie(apiToken) {
  try {
    var amplitudeCookieName = "AMP_".concat(apiToken.substring(0, 10));
    var amplitudeCookie = (0, _utils.default)(amplitudeCookieName);
    var cookieData = JSON.parse(decodeURIComponent(atob(amplitudeCookie)));
    return cookieData === null || cookieData === void 0 ? void 0 : cookieData.deviceId;
  } catch (err) {
    return undefined;
  }
};
var SMAmplitude = exports.default = /*#__PURE__*/function () {
  function SMAmplitude(config) {
    var _this = this;
    _classCallCheck(this, SMAmplitude);
    this.userProps = {};
    this.config = void 0;
    this.amplitudeSdkInitialized = false;
    this.queuedEvents = [];
    this.recheckCookieAttempts = 0;
    this.config = config;

    // only initialize in a browser
    if (typeof window === 'undefined') {
      return;
    }
    this.initialize();

    // we'll listen in on OneTrust's global event for if the consent changes. this way,
    // we don't have to worry about race conditions should this library initialize before
    // the OneTrust one is available
    window.addEventListener('consent.onetrust', function () {
      return _this.handleConsentChange();
    });
  }

  /**
   * Initializes the Amplitude SDK
   */
  _createClass(SMAmplitude, [{
    key: "canSendEvents",
    get:
    /**
     * Returns whether the configuration is valid for sending events
     */
    function get() {
      var _user$session;
      var _this$config = this.config,
        amplitudeToken = _this$config.amplitudeToken,
        user = _this$config.user;
      return (
        // we need an amplitude token...
        !!amplitudeToken &&
        // ...to not be impersonating a user...
        !(user !== null && user !== void 0 && (_user$session = user.session) !== null && _user$session !== void 0 && _user$session.isAdminImpersonation)
      );
    }

    /**
     * Whether the use of functional cookies is allowed or not
     */
  }, {
    key: "canUseFunctionalCookies",
    get: function get() {
      return !(0, _OneTrust.default)(this.config.overrideOneTrust);
    }

    /**
     * Returns whether an event should be sent anonymously (i.e. we can't use functional cookies)
     */
  }, {
    key: "shouldSendAnonymously",
    get: function get() {
      return !this.canUseFunctionalCookies && this.recheckCookieAttempts >= INITIALIZE_RECHECK_MAX;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      // if the configuration isn't there, just bail
      if (!this.canSendEvents) {
        return;
      }
      if (!this.amplitudeSdkInitialized && this.canUseFunctionalCookies) {
        var _this$config2 = this.config,
          amplitudeDeviceId = _this$config2.amplitudeDeviceId,
          amplitudeSessionId = _this$config2.amplitudeSessionId,
          amplitudeToken = _this$config2.amplitudeToken,
          user = _this$config2.user;
        var isAuthenticated = user.isAuthenticated,
          userId = user.id,
          group = user.group;
        var config = _objectSpread({}, DEFAULT_AMPLITUDE_CONFIG);
        conditionallyAddKey('deviceId', amplitudeDeviceId, config);
        conditionallyAddKey('sessionId', amplitudeSessionId, config);

        // if a device ID hasn't been passed explicitly, pull it out of cookies if we can
        // we're not guaranteed that Amplitude will read that value from its own cookie...
        if (!config.deviceId) {
          config.deviceId = getDeviceIdFromCookie(amplitudeToken);
        }
        try {
          // due to the `canSendEvents` check above, amplitudeToken is definitely not undefined
          amplitude.init(amplitudeToken, undefined, config);
          if (isAuthenticated) {
            var _group$membership;
            amplitude.setUserId(userId);
            if (group !== null && group !== void 0 && (_group$membership = group.membership) !== null && _group$membership !== void 0 && _group$membership.groupId) {
              var _group$membership2;
              amplitude.setGroup('teamId', group === null || group === void 0 ? void 0 : (_group$membership2 = group.membership) === null || _group$membership2 === void 0 ? void 0 : _group$membership2.groupId);
            }
          }
          this.hydrateDefaultUserProps();
          this.sendUserProperties();

          // add a bevy of event listeners to detect if the user is leaving the page in
          // some way. this will allow us to flush the event queue and prevent events
          // from being stuck in limbo. why so many events? because different browsers
          // act differently :|
          document.addEventListener('visibilitychange', function () {
            return _this2.flushCache();
          });
          window.addEventListener('pagehide', function () {
            return _this2.flushCache();
          });
          window.addEventListener('beforeunload', function () {
            return _this2.flushCache();
          });

          // flush any events that may have queued before initialization
          this.flushCache();
        } catch (err) {
          // silently fail
        }
        this.amplitudeSdkInitialized = true;
      } else if (!this.canUseFunctionalCookies) {
        // retry checking for cookie consent a few times before falling back to sending
        // events anonymously
        this.recheckCookieAttempts += 1;
        if (!this.shouldSendAnonymously) {
          setTimeout(function () {
            return _this2.initialize();
          }, INITIALIZE_RECHECK_DELAY);
        } else {
          // we're now in anonymous mode. flush any queued events
          this.flushCache();
        }
      }
    }

    /**
     * Sends a tracking event to Amplitude
     *
     * @param event The event and properties to send to Amplitude
     */
  }, {
    key: "track",
    value: function track(event) {
      var data = event.data;
      var amplitudeEvent = data.amplitudeEvent,
        amplitudeUserProperties = data.amplitudeUserProperties;

      // we don't have enough something. bail
      if (!amplitudeEvent || !this.canSendEvents) {
        return;
      }

      // if we're in anonymous mode, kick the event over that way
      if (this.shouldSendAnonymously) {
        (0, _anonymous.default)(this.config, event);
        return;
      }

      // if amplitude is disabled for any reason, stash the event for later
      // in the event it gets re-enabled so unsent events can get fired
      if (!this.canUseFunctionalCookies) {
        this.queuedEvents.push(event);
        return;
      }
      var eventData = (0, _common.prepareEventProperties)(amplitudeEvent, data);

      // if extra user props were in this event, send those along
      if (amplitudeUserProperties) {
        this.sendUserProperties(amplitudeUserProperties);
      }
      amplitude.track(amplitudeEvent, _objectSpread({}, eventData));
    }

    /**
     * Pulls out the default user properties that should be sent upon initialization
     *
     * @param user The user configuration from initialization
     */
  }, {
    key: "hydrateDefaultUserProps",
    value: function hydrateDefaultUserProps() {
      var user = this.config.user;
      var userProps = {};

      // decorate logged in user information
      if (user.isAuthenticated) {
        var _user$group, _user$group$membershi;
        conditionallyAddKey('languageId', user === null || user === void 0 ? void 0 : user.languageId, userProps);
        conditionallyAddKey('languageName', user === null || user === void 0 ? void 0 : user.languageName, userProps);
        conditionallyAddKey('languageCode', user === null || user === void 0 ? void 0 : user.languageCode, userProps);
        conditionallyAddKey('userPackageId', user === null || user === void 0 ? void 0 : user.package, userProps);
        conditionallyAddKey('userPackageName', (user === null || user === void 0 ? void 0 : user.packageCanonicalName) || (user === null || user === void 0 ? void 0 : user.packageName), userProps);
        conditionallyAddKey('userSubscriptionStatus', user === null || user === void 0 ? void 0 : user.subscriptionStatus, userProps);
        conditionallyAddKey('dateJoined', user === null || user === void 0 ? void 0 : user.joinedAt, userProps);
        conditionallyAddKey('dateSubscribed', user === null || user === void 0 ? void 0 : user.subscribedAt, userProps);
        conditionallyAddKey('userRole', (_user$group = user.group) === null || _user$group === void 0 ? void 0 : (_user$group$membershi = _user$group.membership) === null || _user$group$membershi === void 0 ? void 0 : _user$group$membershi.type, userProps);
        conditionallyAddKey('userDataCenter', user === null || user === void 0 ? void 0 : user.dataCenter, userProps);
        conditionallyAddKey('userCountryCode', this.config.country, userProps);
        if (user.email) {
          var _user$email$split = user.email.split('@'),
            _user$email$split2 = _slicedToArray(_user$email$split, 2),
            emailDomain = _user$email$split2[1];
          if (emailDomain && emailDomain.indexOf('.') > -1) {
            userProps.emailDomain = emailDomain;
          }
        }
      }

      // EP-1743: decorate with EP cookie values
      userProps.userSMSessionId = (0, _utils.default)('ep201');
      userProps.userSMPersistentId = (0, _utils.default)('ep202');
      this.userProps = userProps;
    }

    /**
     * Sends default user properties on initialization and additional user properties
     * any time via an Amplitude identify event.
     *
     * @param extraUserProps Additional user properties to send with the defaults
     */
  }, {
    key: "sendUserProperties",
    value: function sendUserProperties(extraUserProps) {
      // only send user props on initialization or if there are extra props to be sent
      if (!this.amplitudeSdkInitialized || extraUserProps) {
        var identify = new amplitude.Identify();
        var userProps = _objectSpread(_objectSpread({}, this.userProps), extraUserProps || {});
        Object.keys(userProps).forEach(function (key) {
          identify.set(key, userProps[key]);
        });
        amplitude.identify(identify);
      }
    }

    /**
     * Event handler for when a user changes OneTrust cookie consent
     */
  }, {
    key: "handleConsentChange",
    value: function handleConsentChange() {
      // if we are no longer able to use functional cookies and we weren't
      // sending events anonymously before, switch to sending events anonymously
      if (!this.canUseFunctionalCookies && !this.shouldSendAnonymously) {
        this.recheckCookieAttempts = INITIALIZE_RECHECK_MAX;
      }

      // if consent has been granted where it wasn't before, initialize everything and send any queued events
      if (!this.amplitudeSdkInitialized && !this.shouldSendAnonymously) {
        this.initialize();
      }

      // flush any queued events
      this.flushCache();
    }

    /**
     * Sends any queued events and flushes the Amplitude event cache
     */
  }, {
    key: "flushCache",
    value: function flushCache() {
      var _this3 = this;
      if (this.canSendEvents) {
        this.queuedEvents.forEach(function (event) {
          return _this3.track(event);
        });
        this.queuedEvents = [];
        if (!this.shouldSendAnonymously) {
          amplitude.flush();
        }
      }
    }
  }]);
  return SMAmplitude;
}();
module.exports = exports.default;
//# sourceMappingURL=index.js.map